var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.57757 8.65232C2.81561 9.04621 2.68927 9.5585 2.29537 9.79655C1.90148 10.0346 1.38919 9.90825 1.15114 9.51435C0.81273 8.95437 0.583126 8.47181 0.448115 8.16031C0.254792 7.71426 0.282842 7.21208 0.51836 6.7915C0.877746 6.14973 1.78563 4.66611 3.18482 3.33307C4.5808 2.00308 6.54507 0.75 8.99848 0.75C11.4519 0.75 13.4162 2.00308 14.8121 3.33307C16.2113 4.66611 17.1192 6.14973 17.4786 6.7915C17.7141 7.21207 17.7422 7.71426 17.5488 8.16031C17.4138 8.47181 17.1842 8.95437 16.8458 9.51435C16.6078 9.90825 16.0955 10.0346 15.7016 9.79655C15.3077 9.5585 15.1814 9.04621 15.4194 8.65232C15.6916 8.20192 15.8805 7.81241 15.995 7.55369C15.6569 6.95778 14.8561 5.67693 13.6625 4.53975C12.4296 3.36514 10.8568 2.41667 8.99848 2.41667C7.14019 2.41667 5.56736 3.36514 4.33447 4.53975C3.14086 5.67693 2.34007 6.95778 2.00194 7.55369C2.1165 7.81241 2.30538 8.20192 2.57757 8.65232Z",
    fill: "#8A9BA3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99848 3.66667C6.69729 3.66667 4.83181 5.53215 4.83181 7.83333C4.83181 10.1345 6.69729 12 8.99848 12C11.2997 12 13.1651 10.1345 13.1651 7.83333C13.1651 5.53215 11.2997 3.66667 8.99848 3.66667ZM6.49848 7.83333C6.49848 6.45262 7.61777 5.33333 8.99848 5.33333C10.3792 5.33333 11.4985 6.45262 11.4985 7.83333C11.4985 9.21405 10.3792 10.3333 8.99848 10.3333C7.61777 10.3333 6.49848 9.21405 6.49848 7.83333Z",
    fill: "#8A9BA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.0d812f34ba90e2bf2eef0aff7c7862ef.svg";
export { ForwardRef as ReactComponent };